<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!-- 合同列表区 start -->
    <add-btn v-hasPermi="['cont:othercontract:add']" @add="addOtherContractHandle(type)" />
    <van-list v-model="otherConLoading" :finished="otherConFinished" finished-text="没有更多了" v-hasPermi="['cont:othercontract:list']" @load="handleOther" v-if="otherList.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item,index) in otherList" :key="index" @click="toContractDetails(item)">
        <div class="flex-c-center" v-if="item">
          <div>
            <div class="custName-wrap">
              <div class="custName">
                {{ item.contractName }}
              </div>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.contractType">{{ contractTypeFormat2(item.contractType) }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.contractStatus">{{
                          contractStatusFormat2(item.contractStatus)
                        }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.payMode">{{ payModeFormat2(item.payMode) }}</van-tag>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.contractMoney">合同金额：{{ item.contractMoney }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.signTime">签约日期：{{ item.signTime | timeFormat }}</van-tag>
            </div>
          </div>
          <van-icon name="arrow" size="16" class="arrow-color" @click="toContractDetails(item)" />
        </div>
      </van-cell>
    </van-list>
    <empty-component @beforeClose="handleSubmitForm" @handleClose="close" v-if="isEmpty" />
    <!-- 合同列表区 end -->
    <!--添加合同信息-->
    <van-dialog v-model="show" title="添加合同信息" :beforeClose="addContractBeforeClose" close-on-click-overlay>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap">
        <van-cell-group>
          <van-field v-model="form.contractName" label="合同标题" :rules="[{ required: true }]" required placeholder="请输入合同标题" />
          <van-field v-model="form.contractNum" label="合同编号" :rules="[{ required: true }]" required placeholder="请输入合同编号" />
          <van-field v-model="form.contractMoney" label="合同金额" :rules="[{ required: true }]" required placeholder="请输入合同金额" />
          <van-field v-model="form.allReturnedMoney" label="合同回款总金额" :rules="[{ required: true }]" required placeholder="请输入合同回款总金额" />
          <van-field v-model="form.noReturnedMoney" label="合同未回款金额" :rules="[{ required: true }]" required placeholder="请输入合同未回款金额" />
          <van-field readonly clickable v-model="form.contractTypeName" @click="showPicker('contractType')" label="合同类型" required :rules="[{ required: true}]" placeholder="请选择合同类型" />
          <van-field readonly clickable v-model="form.businessTypeName" @click="showPicker('businessTypeId')" v-if="form.contractType==1" label="产品类型" :rules="[{ required: true }]" placeholder="请选择产品类型" required />
          <van-field readonly clickable v-model="form.contractStatusName" @click="showPicker('contractStatus')" label="合同状态" equired :rules="[{ required: true}]" placeholder="请选择合同状态" />
          <van-field readonly clickable v-model="form.payModeName" @click="showPicker('payMode')" label="支付方式" required :rules="[{ required: true}]" placeholder="请选择支付方式" />
          <van-field v-model="form.startTime" readonly clickable name="calendar" label="开始时间" placeholder="点击选择日期" @click="showStartCalendar = true" required :rules="[{ required: true}]" />
          <van-field v-model="form.endTime" readonly clickable name="calendar" label="结束时间" placeholder="点击选择日期" @click="showEndCalendar = true" required :rules="[{ required: true }]" />
          <van-field v-model="form.signTime" readonly clickable name="calendar" label="签约日期" placeholder="点击选择日期" @click="showSignCalendar = true" required :rules="[{ required: true }]" />
          <van-field v-model="form.custSignedUser" label="对方签约人" />
          <van-field v-model="form.signedUserMobile" label="对方电话" placeholder="请填写对方电话" />
          <van-field v-model="form.mySignedUser" label="我方签约人" placeholder="请输入我方签约人" :rules="[{ required: true }]" required />
          <van-field name="uploader" label="合同相片">
            <template #input>
              <van-uploader v-model="pictureList" :after-read="uploadContractPictureFiles" :before-read="beforeRead" :deletable="true" :before-delete="handleContractRemove" :max-count="9" :multiple="true" :max-size="52428800" upload-text="合同相片" />
            </template>
          </van-field>
          <van-field name="rate" label="电子合同">
            <template #input>
              <van-uploader v-model="fileList" :after-read="uploadContractFiles" :max-count="1" :max-size="52428800" upload-text="电子合同" required>
              </van-uploader>
            </template>
          </van-field>
          <van-field name="rate" label="附件1">
            <template #input>
              <van-uploader v-model="fileList1" :after-read="uploadContractFiles1" :max-count="1" :max-size="52428800" upload-text="附件1">
              </van-uploader>
            </template>
          </van-field>
          <van-field name="rate" label="附件2">
            <template #input>
              <van-uploader v-model="fileList2" :after-read="uploadContractFiles2" :max-count="1" :max-size="52428800" upload-text="附件2">
              </van-uploader>
            </template>
          </van-field>
          <van-field v-model="form.remark" label="备注" />
          <van-field v-model="form.content" rows="2" type="textarea" label="合同内容" />
        </van-cell-group>
      </van-form>
    </van-dialog>

    <!--客户搜索-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />

    <!-- 日期选择器 -->
    <van-calendar v-model="showStartCalendar" :min-date="minDate" type="single" @confirm="onStartCalendarConfirm" />
    <van-calendar v-model="showEndCalendar" :min-date="minDateStart" type="single" @confirm="onEndCalendarConfirm" />
    <van-calendar v-model="showSignCalendar" :min-date="minDate" type="single" @confirm="onSignCalendarConfirm" />
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
import {
  listContract,
  updateContract,
  exportContract,
} from "@/api/cont/contract";
import { addOtherContract, listOtherContract } from "@/api/cont/othercontract";
import { selectAllBusinessType } from "@/api/scrm/custbusinesstype";
import { ucloudUpFileToContract, deleteFile } from "@/api/system/common";
import { getDicts } from "@/api/system/dict/data";
import AddBtn from "@/components/common/AddBtn";
import SearchComponent from "@/components/common/Search";
import EmptyComponent from "@/components/common/Empty";
import TotalComponent from "@/components/common/Total";
import SearchPop from '../components/contract/SearchPop.vue'
export default {
  components: {
    AddBtn,
    SearchComponent,
    EmptyComponent,
    TotalComponent,
    SearchPop
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      isEmpty: false,
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
      },
      loading: false,
      finished: false,
      noConLoading: false,
      noConFinished: false,
      failConLoading: false,
      failConFinished: false,
      otherConLoading: false,
      otherConFinished: false,
      showFilterPop: false,
      fileList: [],
      fileList1: [],
      fileList2: [],
      deleteFileList: [],
      captureList: [],
      pictureList: [],
      list: [],
      total: 0,
      noList: [],
      failList: [],
      otherList: [],
      type: "add",
      show: false,
      searchParams: {
        visible: false,
      },
      searchValue: "",
      custList: [],
      // 客户等级
      custLevelOptions: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // 客户类型字典
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      // 提单状态
      boStatusOptions: this.$store.state.dictOptions.custBoStatus || [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      //投放类型列表
      launchTypeOptions: this.$store.state.dictOptions.custOrderLaunchType || [],
      //产品类型列表
      businessTypeOptions: this.$store.state.dictOptions.businessTypeTree|| [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [],
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      active: 0,
      // 列表
      activeName: "active_othercontract",
      form: {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: '2',
        contractType: null,
        contractStatus: null,
        businessTypeName: null,
        businessType: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        startTime: null,
        endTime: null,
        signedUserMobile: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractSource: "2",
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      //修改主体框架标题
      document.title = "CONT-合同信息";
      await this.handleOther();
    },
    contractTypeFormat2(contractType) {
      return this.selectDictLabel(this.contractTypeOptions, contractType);
    },
    contractStatusFormat2(contractStatus) {
      return this.selectDictLabel(this.contractStatusOptions, contractStatus);
    },
    //支付方式字典翻译
    payModeFormat2(payMode) {
      return this.selectDictLabel(this.payModeOptions, payMode);
    },
    payModeFormat(row, column) {
      return this.selectDictLabel(this.payModeOptions, row.payMode);
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + "-" + month + "-" + day;
    },
    onStartCalendarConfirm(data) {
      this.form.startTime = this.formatDate(data);
      this.showStartCalendar = false;
      this.minDateStart = data
    },
    onEndCalendarConfirm(data) {
      this.form.endTime = this.formatDate(data);
      this.showEndCalendar = false;
    },
    onSignCalendarConfirm(data) {
      this.form.signTime = this.formatDate(data);
      this.showSignCalendar = false;
    },
    // 根据子组件search传值过来的data，就是searchValue
    queryContractList() {
      this.otherList = [];
      this.queryParams.pageNum = 1
      this.handleOther();
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.resetQuery()
      this.queryParams.contractName = this.searchValue = data;
      this.queryContractList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      let query = this.queryParams;
      this.queryParams = { ...query, ...data }
      this.queryContractList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    // 返回布尔值
    beforeRead(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        Toast("请上传 jpg 、jpeg、png 格式图片");
        return false;
      }
      return true;
    },
    // 返回布尔值
    beforeFileRead(file) {
      if (file.type !== "pdf") {
        Toast("请上传 pdf 格式图片");
        return false;
      }
      return true;
    },
    getImg(images) {
      ImagePreview({
        images: [images],
        showIndex: false,
        loop: false,
      });
    },
    toContractDetails(item) {
      this.$router.push({
        name: "contractdetail",
        query: {
          id: item.contractId,
          verifyStatus: item.verifyStatus,
          contractSource: item.contractSource,
        },
      });
    },
    showPicker(type) {
      this.picker.formKey = type;
      if (type === "contractType") {
        this.picker.columns = this.contractTypeOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "contractStatus") {
        this.picker.columns = this.contractStatusOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === 'businessTypeId') {
        this.picker.columns = this.businessTypeOptions.map(ele => this.businessNormalizer(ele))
      }
      if (type === "payMode") {
        this.picker.columns = this.payModeOptions.map((ele) => ele.dictLabel);
      }
      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "contractType") {
        this.form.contractType = this.contractTypeOptions[index].dictValue;
        this.form.contractTypeName = this.contractTypeOptions[index].dictLabel;
      }
      if (this.picker.formKey === "contractStatus") {
        this.form.contractStatus = this.contractStatusOptions[index].dictValue;
        this.form.contractStatusName =
          this.contractStatusOptions[index].dictLabel;
      }
      if (this.picker.formKey === "payMode") {
        this.form.payMode = this.payModeOptions[index].dictValue;
        this.form.payModeName = this.payModeOptions[index].dictLabel;
      }
      // 产品类型
      if (this.picker.formKey === 'businessTypeId') {
        if (value.length == 2) {
          if (value[1].length > 0) {
            this.form.businessTypeName = value[0] + '/' + value[1]
            let obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
            if (obj != null) {
              this.form.businessType = obj.children.find(item => item.businessTypeName === value[1]).businessTypeId
            }
          }

        } else {
          this.form.businessTypeName = value[0]
          let obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
          if (obj != null) {
            this.form.businessType = obj.businessTypeId
          }
        }

      }
      this.picker.visible = false;
    },

    pickerCancel() {
      this.picker.visible = false;
    },
    /** 转换产品类型数据结构 */
    businessNormalizer(node) {
      console.log(node);
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].businessTypeId,
            text: node.children[i].businessTypeName
          }
          arr.push(item)
        }
      }
      return {
        id: node.businessTypeId,
        text: node.businessTypeName,
        children: arr
      };
    },
    // 关闭弹框
    close() {
      console.log('子组件执行handleClose');
      this.show = false;
    },
    handleSubmitForm(data) {
      console.log('父级 handleSubmitForm', data);
      addOtherContract(data).then((response) => {
        Toast.success("添加成功");
        this.show = false;
        this.handleOther();
      });
    },
    //添加合同
    async addContractBeforeClose(type, done) {
      if (type === "confirm") {
        try {
          await this.$refs["form"].validate();
          addOtherContract(this.form).then((response) => {
            Toast.success("添加成功");
            if (this.deleteFileList.length > 0) {
             // deleteFile(this.deleteFileList);
            }
            this.show = false;
            this.handleOther();
          });
          done();
        } catch (err) {
          return done(false);
        }
        return done(false);
      } else {
        return done();
      }
    },
    handleContractRemove(file) {
      let picture = this.form.contractImg;
      console.log(file.url);
      if (picture.indexOf(file.url) == 0) {
        if (picture.indexOf(",") == -1) {
          picture = null;
        } else {
          picture = picture.replace(file.url + ",", "");
        }
      } else {
        picture = picture.replace("," + file.url, "");
      }
      this.form.contractImg = picture;
      console.log(this.form.contractImg);
      this.pictureList = [];
      if (this.form.contractImg != null && this.form.contractImg.length > 0) {
        let payCaptures = this.form.contractImg.split(",");
        payCaptures.forEach((element) => {
          this.pictureList.push({
            url: element,
          });
        });
      }
      this.deleteFileList.push(file.url);
      console.log(this.deleteFileList);
    },
    uploadContractPictureFiles(file) {
      console.log(file);
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            // this.form.contractImg = res.url;
            let picture = this.form.contractImg;
            if (picture != null && picture.length > 0) {
              picture += "," + res.url;
            } else {
              picture = res.url;
            }
            this.form.contractImg = picture;
            let payCaptures = this.form.contractImg.split(",");
            this.pictureList = [];
            payCaptures.forEach((element) => {
              this.pictureList.push({
                url: element,
              });
            });
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.contractFile = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles1(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.annexOne = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles2(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.annexTwo = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    pickerChange() { },
    addOtherContractHandle(type, row) {
      this.reset();
      this.fileList = [];
      this.fileList1 = [];
      this.fileList2 = [];
      this.pictureList = [];
      this.deleteFileList = [];
      this.type = type;
      this.show = true;
    },
    confirm() {
      let api = this.type !== "add" ? updateContract : addContract,
        msg = this.type !== "add" ? '修改成功' : '新增成功';
      api(this.form).then((response) => {
        Toast(msg);
        this.dialogVisible = false;
        this.handleOther();
      });
    },
    async handleOther() {
      this.otherConLoading = true;
      this.queryParams.contractSource = "2";
      const res = await listOtherContract(this.queryParams);
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.otherList = this.otherList.concat(res.rows);
        this.queryParams.pageNum += 1;
        this.total = res.total;
        this.otherConLoading = false;
        this.otherConFinished = this.otherList.length >= res.total;
        this.showFilterPop = false
      }
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: "1",
        contractType: null,
        contractStatus: null,
        businessTypeName: null,
        businessType: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        startTime: null,
        endTime: null,
        signedUserMobile: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        status: null,
      };
    },
    reset() {
      this.form = {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: '2',
        contractType: null,
        contractStatus: null,
        businessTypeName: null,
        businessType: null,
        payMode: null,
        contractTypeName: null,
        contractStatusName: null,
        payModeName: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        allReturnedMoney: null,
        noReturnedMoney: null,
        startTime: null,
        endTime: null,
        signedUserMobile: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      };
    },
  },
};
</script>



